export const TOKEN_LENGTH = 6

export const RESEND_TOKEN_TIME = 60
